function PageTitle({title}: { title: string }) {
    return (
        <h1 className="mt-4 mb-3">
            {title}
        </h1>
    )
}

export default PageTitle;